import React, { useCallback, useMemo } from "react";
import AppEngine from "../../apps/AppEngine";
import { SERVER_SIDE_CACHE_KEYS } from "~/constants";
import { getServerHostKey, getServerHostUrl, isDemoEnvironment, isLocalDev } from "rylak-common";
import _ from "lodash";

export default function ProdEnvironment(props) {
    const { Page, router, queryClient, serverSideProps } = props;
    const { brandName, url } = serverSideProps;

    const serverHostKey = getServerHostKey(url);
    const serverHostUrl = getServerHostUrl(url);

    const system = useMemo(
        () => ({
            fetch: fetch,
            host: serverHostUrl,
        }),
        [serverHostUrl],
    );

    // Helping navigate function to pre-populate brand in the query
    const navigate = useCallback((url, as, options) => {
        if (_.isObject(url)) {
            return router.push({ ...url, query: { brand: router.query.brand, ...url.query } }, as, options);
        } else {
            return router.push(url, as, options);
        }
    }, []);

    const includeReturnReasons = isDemoEnvironment() || isLocalDev();

    // Retrieve the server side cached init response data
    // Is generated from getServerSideProps
    const initServiceData = queryClient.getQueryData([SERVER_SIDE_CACHE_KEYS.INIT, brandName, serverHostKey, includeReturnReasons]);

    const brandData = initServiceData?.data;

    return <AppEngine Page={Page} brandName={brandName} brandData={brandData} router={router} navigate={navigate} system={system} initServiceData={initServiceData} />;
}
